import React, { Fragment } from "react";

import Layout from "layout";
import Container from "layout/Container";
import Collapsible from "elements/Collapsible";
import ContactUs from "./HelpCenter/ContactUs";
import LimitationOfLiability from "./TermsAndConditions/LimitationOfLiability";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";
import { sanitizeHtml } from "../../services/sanitizeHtml";

const StaticPage = (props) => {
  const { pageContent, module } = props.pageContext;
  const hasContactUs = module.title === "Help Center";
  const hasLimitationOfLiability =
    module.title === "Terms and Conditions" && module.name === "mind";
  const hasDPOImage = module.title === "Privacy Policy";

  const data = useStaticQuery(graphql`
    {
      dpo: file(relativePath: { eq: "DPO.png" }) {
        childImageSharp {
          fixed(width: 170, quality: 100) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `);
  const dpo = data.dpo.childImageSharp.fixed;

  return (
    <Layout
      seoTitle={module.seoTitle}
      display={{ helpCenterBanner: false, footer: true }}
    >
      <Container isCentered>
        <h2>{module.title}</h2>
        <hr />
        {hasDPOImage && pageContent?.[0]?.body && (
          <div className="columns is-vcentered is-justify-content-center">
            <div className="column is-narrow has-text-centered">
              <Img className="m-1" fixed={dpo} alt="dpo" />
            </div>
            <div
              className="mb-2 content column"
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(
                  pageContent?.[0]?.body.childMarkdownRemark.html.replace(
                    /\n/g,
                    "<br />"
                  )
                ),
              }}
            />
          </div>
        )}
        {!hasDPOImage && pageContent?.[0]?.body && (
          <div
            className="mb-2 content"
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(
                pageContent?.[0]?.body.childMarkdownRemark.html.replace(
                  /\n/g,
                  "<br />"
                )
              ),
            }}
          />
        )}
        {pageContent.map((content) => {
          const currentSection = pageContent.find(
            (sectionContent) => sectionContent.section === content?.section
          );
          const isFirstInSection =
            content?.answer?.childMarkdownRemark?.html ===
            currentSection?.answer?.childMarkdownRemark?.html;
          if (content?.question && content?.answer)
            return (
              <Fragment>
                {isFirstInSection && <h4>{content.section}</h4>}
                <Collapsible title={content.question}>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: sanitizeHtml(
                        content.answer.childMarkdownRemark.html
                          .replace(/\n/g, "<br />")
                          .replace(/[\\]/g, "")
                      ),
                    }}
                  ></p>
                </Collapsible>
              </Fragment>
            );
          return null;
        })}
        {hasContactUs && <ContactUs module={module} />}
        {hasLimitationOfLiability && <LimitationOfLiability />}
      </Container>
    </Layout>
  );
};

export default StaticPage;
